module.exports = __webpack_public_path__ + "src/assets/img/dachiev.ce7dc987.png";